import { IconLinkArrow } from "@repo/assets/images";
import { getStrapiMedia } from "@repo/lib/utils";
import cx from "classnames";
import Image from "next/image";
const Card = ({
  item
}) => {
  const {
    title,
    media,
    subText,
    url,
    urlText
  } = item;
  return <div className="group" data-sentry-component="Card" data-sentry-source-file="Card.jsx">
      <div key={item?.id} className="relative">
        {media?.url && <div className="group overflow-hidden">
            <Image src={getStrapiMedia(media?.url)} alt={media?.alternativeText || title || ""} width={media?.width} height={media?.height} className="mx-auto transition-all duration-500 ease-in-out md:group-hover:scale-110 rtl:-scale-x-100 rtl:md:group-hover:-scale-x-110" />
          </div>}

        <div className="absolute inset-0 flex">
          <div className="flex size-full flex-col justify-between p-4 md:px-8 md:py-6">
            <div>
              {subText && <p className="text-primarygray text-xs font-medium md:pb-2 md:text-sm">
                  {subText}
                </p>}
              {title && <h2 className={cx("font-heading text-primarygray rtl:font-arabic mt-1 max-w-[75%] text-xl font-normal leading-tight md:text-2xl")}>
                  {title}
                </h2>}
            </div>
            {url && urlText && <div className="text-primarygray inline-flex items-center gap-2 text-sm font-medium">
                {urlText}
                <IconLinkArrow className="size-3 rtl:rotate-180" />
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
export default Card;